// Configuración compartida del módulo de Entrevistas / Reclutamiento - Beeznz Work

export type FieldType =
  | 'texto_corto'
  | 'texto_largo'
  | 'opcion_multiple'
  | 'casillas'
  | 'lista'
  | 'fecha'
  | 'numero'
  | 'si_no'
  | 'escala'
  | 'archivo'
  | 'comentario'

export interface TemplateField {
  id: string
  label: string
  type: FieldType
  required: boolean
  options?: string[]
  scaleMax?: number
}

export const FIELD_TYPE_LABELS: Record<FieldType, string> = {
  texto_corto: 'Texto corto',
  texto_largo: 'Texto largo',
  opcion_multiple: 'Opción múltiple',
  casillas: 'Casillas de verificación',
  lista: 'Lista desplegable',
  fecha: 'Fecha',
  numero: 'Número',
  si_no: 'Sí / No',
  escala: 'Escala de evaluación',
  archivo: 'Adjuntar archivo',
  comentario: 'Comentarios internos',
}

// Categorías sugeridas de plantillas
export const TEMPLATE_CATEGORIES = [
  'Operativos',
  'Administrativos',
  'Ventas',
  'Recursos Humanos',
  'Producción',
  'Gerenciales',
  'Tecnología',
  'Atención al cliente',
]

// Competencias sugeridas (la empresa puede personalizarlas)
export const DEFAULT_COMPETENCIES = [
  'Comunicación',
  'Liderazgo',
  'Trabajo en equipo',
  'Puntualidad',
  'Responsabilidad',
  'Experiencia',
  'Conocimientos técnicos',
  'Resolución de problemas',
  'Adaptabilidad',
  'Actitud',
]

// Etapas por defecto del flujo de reclutamiento
export const RECRUITMENT_STAGES = [
  'Postulación',
  'Filtro inicial',
  'Entrevista RH',
  'Entrevista técnica',
  'Entrevista con jefe directo',
  'Entrevista final',
  'Contratado',
  'No seleccionado',
  'Banco de talento',
]

export type InterviewResult =
  | 'aprobado'
  | 'aprobado_observaciones'
  | 'pendiente'
  | 'no_aprobado'
  | 'banco_talento'

export const RESULT_LABELS: Record<InterviewResult, string> = {
  aprobado: 'Aprobado',
  aprobado_observaciones: 'Aprobado con observaciones',
  pendiente: 'Pendiente',
  no_aprobado: 'No aprobado',
  banco_talento: 'Mantener en banco de talento',
}

export const RESULT_STYLES: Record<InterviewResult, string> = {
  aprobado: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  aprobado_observaciones: 'bg-amber-50 text-amber-700 border border-amber-200',
  pendiente: 'bg-slate-100 text-slate-600 border border-slate-200',
  no_aprobado: 'bg-red-50 text-red-700 border border-red-200',
  banco_talento: 'bg-violet-50 text-violet-700 border border-violet-200',
}

export type InterviewStatus = 'programada' | 'en_proceso' | 'completada' | 'cancelada'

export const INTERVIEW_PROC_LABELS: Record<InterviewStatus, string> = {
  programada: 'Programada',
  en_proceso: 'En proceso',
  completada: 'Completada',
  cancelada: 'Cancelada',
}

export const INTERVIEW_PROC_STYLES: Record<InterviewStatus, string> = {
  programada: 'bg-blue-50 text-blue-700',
  en_proceso: 'bg-amber-50 text-amber-700',
  completada: 'bg-emerald-50 text-emerald-700',
  cancelada: 'bg-slate-100 text-slate-500',
}

export function genFieldId(): string {
  return 'f_' + Math.random().toString(36).slice(2, 9)
}
